/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {Promise}
 */
function getBlob(url) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();

    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}

/**
 * 保存
 * @param  {Blob} blob
 * @param  {String} filename 想要保存的文件名称
 */
function saveAs(blob, filename, loading) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement("a");
    const body = document.querySelector("body");

    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // fix Firefox
    link.style.display = "none";
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);

    loading ? loading.close() : "";
  }
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export const download = (url, filename, loading) => {
  getBlob(url).then((blob) => {
    saveAs(blob, filename, loading);
  });
};

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
export const isUndef = (v) => {
  return v === undefined || v === null;
};
export const isDef = (v) => {
  return v !== undefined && v !== null;
};
export const isTrue = (v) => {
  return v === true;
};
export const isFalse = (v) => {
  return v === false;
};
/**
 * Convert a value to a string that is actually rendered.
 */
export const toString = (val) => {
  return val == null
    ? ""
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
    ? JSON.stringify(val, null, 2)
    : String(val);
};
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
export const toNumber = (val) => {
  var n = parseFloat(val);
  return isNaN(n) ? val : n;
};

/**
 * Remove an item from an array.
 */
export const remove = (arr, item) => {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};
/**
 * Check whether an object has the property.
 */
export const hasOwn = (obj, key) => {
  let hasOwnProperty = Object.prototype.hasOwnProperty;
  return hasOwnProperty.call(obj, key);
};
/**
 * Merge an Array of Objects into a single Object.
 */
export const toObject = (arr) => {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};
/**
 * Removing Duplicate Elements from Arrays
 */
export const deteleObject = (obj) => {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
    var keys = Object.keys(obj[i]);
    keys.sort(function(a, b) {
      return Number(a) - Number(b);
    });
    var str = "";
    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(obj[i][keys[j]]);
    }
    if (!stringify.hasOwnProperty(str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  uniques = uniques;
  return uniques;
};

export const format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
export const toJSON = () => {
  return this.format("yyyy-MM-dd hh:mm:ss"); // util.formatDate是自定义的个时间格式化函数
};

import FileSaver from "file-saver";
import XLSX from "xlsx";
// 导出表格所用
export const exportExcel = (id = ".user-table", typeName = "文件类型") => {
  // 设置当前日期
  let time = new Date();
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let name = year + "_" + month + "_" + day + "_" + typeName;
  // //(name)
  /* generate workbook object from table */
  //  .table要导出的是哪一个表格
  var wb = XLSX.utils.table_to_book(document.querySelector(id));
  /* get binary string as output */
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    //  name+'.xlsx'表示导出的excel表格名字
    FileSaver.saveAs(
      new Blob([wbout], {
        type: "application/octet-stream",
      }),
      name + ".xlsx"
    );
  } catch (e) {
    // if (typeof console !== "undefined") //(e, wbout);
  }
  return wbout;
};

/**
 * @param data 数据
 * @param fileName 文件名称
 * @param type 导出文件类型
 */
export const downloadMore = (data, fileName, type) => {
  // 创建 blob
  const blob = new Blob([data], {
    type: mineType[type],
  });
  // 创建 href 超链接，点击进行下载
  window.URL = window.URL || window.webkitURL;
  const href = URL.createObjectURL(blob);
  const downA = document.createElement("a");
  downA.href = href;
  downA.download = fileName;
  downA.click();
  // 销毁超连接
  window.URL.revokeObjectURL(href);
};

export const mineType = {
  excel: "application/vnd.ms-excel", // 下载 Excel
  word: "application/msword", // 下载 Word
  zip: "application/zip", // 下载 Zip
  zzip: "application/7z", // 下载 Zip
  html: "text/html", // 下载 Html
  markdown: "text/markdown", // 下载 Markdown
};

export const parseAddress = (str) => {
  if (typeof str == "object")
    return str.community && str.community.length
      ? str.address.join(",") + "/" + str.community
      : str.address.join(",");
  if (str && str.length) {
    const [addressStr, community = ""] = str.split("/");
    return {
      address: addressStr ? addressStr.split(",") : [],
      community,
    };
  } else {
    return { address: [], community: "" };
  }
};
